<template>
  <div class="container">
    <img :src="getImageUrl()"/>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      uri: ''
    }
  },
  created () {
    this.uri = this.$route.query.uri
  },
  methods: {
    getImageUrl () {
      return commonUtils.getImageUrl(this.uri)
    }
  }
}
</script>
<style lang="less" scoped>
.container{
  img{
    width: 100%;
  }
}
</style>
